/**
 * Search API
 *
 * @author Jaehyub.lee@emcast.com
*/
import httpService from "@/api/httpService";

const searchApi = {
    // 검색 api
    // params : Pageable(sort, size, page), search(string), category(Long), tags(Array<Long>)
    search(params) {
        return httpService.get(`/learn/online/degree/search`, params);
    },

    // 추천 검색어
    // params : itemCount(Number)
    getRecommendTags(params) {
        return httpService.get(`/learn/online/degree/tags/popular`, params)
    },
}

// export const 
export default searchApi;